export const PUBLIC = process.env.PUBLIC_URL || '';
export const MAPS_URL = 'https://maps.app.goo.gl/Gt24Kgw5hjzY4rG36';
export const GOLD = '#c9a24b';
export const GOLD_LT = '#e2be76';
export const CREAM = '#f3ead6';
export const INK = '#16110c';
